let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
export const StyledScrollableDiv = styledWithTheme.div(_t || (_t = _`
  height: 100%;
  overflow-y: auto;
  width: 100%;
  ${0}
  padding-block: ${0};
`), ({
  maxHeight
}) => maxHeight && `max-height: ${maxHeight};`, ({
  theme
}) => theme.space['200']);